<template>
  <div class="liquor-country">
    <Header active="/liquor/country" />
    <div class="header">
      <div class="left">
        <img :src="util.getFirstImage(item.map)" />
      </div>
      <div class="right">
        <div class="country">{{item.country}}</div>
        <div class="intro">{{item.intro}}</div>
        <div class="level" v-if="item.levelImage">
          <img class="level-image" :src="util.getFirstImage(item.levelImage)" />
          <div class="level-intro">
            <div class="text">{{item.levelIntro}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="area">
      <div class="title">
        <div class="title-before"></div>
        <div class="title-after">产区信息</div>
      </div>

      <div class="body">
        <div
          class="item"
          v-for="(item, index) in areaList"
          :key="index"
          @click="goto('/liquor/area/' + item.id)"
        >
          <div class="item-title">
            <div class="area-name">{{item.area}}</div>
            <div class="arrow-right">
              <img src="/liquor/menu_arrow@2x.png" />
            </div>
          </div>
          <div
            class="commodity-name"
            v-for="(item, index) in item.commodityList"
            :key="index"
          >{{item.name}}{{ item.nameEn ? ' / ' : ''}}{{item.nameEn}}</div>
        </div>
      </div>
    </div>

    <div class="commodity">
      <div class="title">
        <div class="title-before"></div>
        <div class="title-after">酒类单品</div>
      </div>
      <div class="body">
        <div
          class="item"
          v-for="(item, index) in commodityList"
          :key="index"
          @click="goto('/liquor/detail/' + item.id)"
        >
          <div class="left">
            <img :src="util.getFirstImage(item.multimedia)" />
          </div>
          <div class="right">
            <div class="commodity-title">{{item.name}}{{ item.nameEn ? ' / ' : ''}}{{item.nameEn}}</div>
            <div class="key-value">
              <div class="key">产区：</div>
              <div class="value">{{item.area}}</div>
            </div>
            <div class="key-value">
              <div class="key">酒类级别评定：</div>
              <div class="value">{{item.level.split(' ').join('/')}}</div>
            </div>
            <div class="key-value">
              <div class="key">酒类介绍</div>
              <div class="value">{{item.wineReview}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Sticky />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import Sticky from "@/components/liquor/Sticky";
import MultiMedia from "@/components/liquor/MultiMedia";

export default {
  name: "LiquorCountry",
  components: {
    Header,
    Sticky,
    MultiMedia
  },
  data() {
    return {
      item: {
        counrty: "",
        map: "",
        intro: "",
        introImage: ""
      },
      areaList: [],
      commodityList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let response;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCountry",
        methodName: "get",
        params: {
          id: this.$route.params.id
        }
      });
      this.item = response;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCommodity",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          numPerPage: 50,
          country: this.item.country
        }
      });
      this.commodityList = response.results;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorArea",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          numPerPage: 50,
          country: this.item.country
        }
      });
      this.areaList = response.results.map(e => {
        return {
          ...e,
          commodityList: this.commodityList
            .filter(c => c.area === e.area)
            .slice(0, 2)
        };
      });
    },
    goto(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
.liquor-country {
  .header {
    width: 1100px;
    margin: 110px auto 110px auto;
    .left {
      width: 538px;
      display: inline-block;
      vertical-align: top;
      margin-right: 40px;
      img {
        width: 538px;
      }
    }

    .right {
      width: 522px;
      display: inline-block;
      vertical-align: top;

      .country {
        height: 33px;
        font-size: 30px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(0, 0, 0, 1);
        line-height: 33px;
      }

      .intro {
        margin-top: 35px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 30px;
      }

      .level {
        margin-top: 30px;
        width: 522px;

        position: relative;

        .level-image {
          width: 522px;
        }

        .level-intro {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 0px;
          right: 0px;
          width: 261px;
          height: 356px;

          .text {
            padding: 20px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(194, 139, 43, 1);
            line-height: 17px;
          }
        }
      }
    }
  }

  .area {
    width: 1100px;
    margin: 0 auto;
    border-top: 1px solid #d8d8d8;

    .title {
      margin: 30px 0;
      height: 22px;
      font-size: 20px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(59, 41, 9, 1);
      line-height: 22px;
    }

    .title-before {
      display: inline-block;
      margin-right: 10px;
      width: 6px;
      height: 12px;
      background: rgba(228, 200, 150, 1);
    }

    .title-after {
      display: inline-block;
    }

    .body {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 522px;
        margin-bottom: 30px;
        cursor: pointer;
        .item-title {
          margin-bottom: 10px;
          .area-name {
            display: inline-block;
            height: 25px;
            background: rgba(228, 200, 150, 1);
            font-size: 12px;
            line-height: 25px;
            padding: 0 10px;
          }

          .arrow-right {
            float: right;
            img {
              width: 6px;
              height: 11px;
            }
          }
        }

        .commodity-name {
          width: 522px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          height: 20px;
          line-height: 20px;
          margin-bottom: 5px;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .item:hover {
        background: rgba(255, 248, 235, 1);
      }
    }
  }

  .commodity {
    width: 1100px;
    margin: 0 auto;
    border-top: 1px solid #d8d8d8;
    .title {
      margin: 30px 0;
      height: 22px;
      font-size: 20px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(59, 41, 9, 1);
      line-height: 22px;
    }

    .title-before {
      display: inline-block;
      margin-right: 10px;
      width: 6px;
      height: 12px;
      background: rgba(228, 200, 150, 1);
    }

    .title-after {
      display: inline-block;
    }

    .body {
      .item {
        width: 1060px;
        margin-bottom: 10px;
        padding: 20px;
        background: rgba(250, 250, 250, 1);
        cursor: pointer;

        .left {
          display: inline-block;
          vertical-align: top;
          width: 180px;
          height: 180px;
          margin-right: 20px;
          text-align: center;
          background: rgba(255, 255, 255, 0.9);
          overflow: hidden;

          img {
            // width: 180px;
            height: 180px;
          }
        }

        .right {
          display: inline-block;
          vertical-align: top;
          .commodity-title {
            max-width: 858px;
            // height: 25px;
            font-size: 18px;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
            line-height: 25px;

            margin-bottom: 25px;
          }

          .key-value {
            margin-bottom: 10px;
            .key {
              display: inline-block;
              vertical-align: top;
              width: 120px;
              height: 20px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(132, 135, 145, 1);
              line-height: 20px;
            }

            .value {
              display: inline-block;
              vertical-align: top;
              max-width: 738px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
            }
          }
        }
      }

      .item:hover {
        background: rgba(255, 248, 235, 1);
      }
    }
  }
}
</style>

